/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník všech podporovaných platforem.
 * Platforma představuje prostředí, ve kterém se aplikace spouští.
 * Platforma určuje dostupné funkcionality, kterých může aplikace využít.
 * @enum {string}
 */
const Platform = {
  /** Platforma Ki-Wi Lighter API. */
  KiwiLighter1: 'kiwi-lighter-1',
  /** Platforma Samsung Smart Signage Platform ve verzi 4. */
  TizenSssp4: 'tizen-sssp-4',
  /** Platforma Samsung Smart Signage Platform ve verzi 5. */
  TizenSssp5: 'tizen-sssp-5',
  /** Platforma Samsung Smart Signage Platform ve verzi 6. */
  TizenSssp6: 'tizen-sssp-6',
  /** Platforma standardních webových technologií. */
  Web: 'web',
  /** Platforma LG webOS Smart Signage Platform ve verzi 3.0. */
  WebosSignage3_0: 'webos-signage-3.0',
  /** Platforma LG webOS Smart Signage Platform ve verzi 3.2. */
  WebosSignage3_2: 'webos-signage-3.2',
  /** Platforma LG webOS Smart Signage Platform ve verzi 4.0. */
  WebosSignage4_0: 'webos-signage-4.0',
  /** Platforma LG webOS Smart Signage Platform ve verzi 4.1. */
  WebosSignage4_1: 'webos-signage-4.1',
  /** Platforma LG webOS Smart Signage Platform ve verzi 6.0. */
  WebosSignage6_0: 'webos-signage-6.0'
};

export default Platform;
